import React, { useEffect, useRef } from 'react';
import { useFetchFavouriteMatchesData } from '../data/fetchFavouriteMatchesData';
import { parseMatchData } from '../data/parseMatchData';
import { filterSearchResults, toggleFavouriteMatchInStorage } from '../data/utils';
import { getLabel } from '../InitData';
import { FavoritesContext } from './FavoritesContextProvider';
import FavouritesListSport from './FavouritesListSport';
import Loader from './Loader';

function FavouritesList(props) {
    const favoritesContext = React.useContext(FavoritesContext);
    const favorites = favoritesContext.favorites;
    const noFavorites = Object.keys(favorites).length === 0;
    const [state] = useFetchFavouriteMatchesData(favorites, true, !noFavorites);
    const noData = useRef(true);
    
    useEffect(() => {
        if (state.data) {
            if (noData.current) {
                noData.current = false;
            }
            const favsToRemove = [];
            for (let matchId in favorites) {
                const match = favorites[matchId];
                const key = match.pal + '_' + match.avv;
                // If match data is null, remove match from favorites
                if (state.data[key] === undefined) {
                    favsToRemove.push(match.uniqueId);
                    toggleFavouriteMatchInStorage(match.uniqueId, match, match.idAggregata);
                } else {
                    const matchData = JSON.parse(state.data[key]);
                    if (matchData.ags.find(ag => ag === match.idAggregata) === undefined) {
                        // The main bet group is closed, so I show the locks in place of the odds
                        match.bets.forEach(bet => {
                            bet.odds.forEach(odd => odd.value = null);
                        });
                    } else {
                        const parsedData = parseMatchData(matchData, match.idAggregata, match, true);
                        favorites[matchId] = {
                            ...match,
                            ...parsedData
                        };
                    }
                }
            }
            favsToRemove.forEach(matchId => {
                delete favorites[matchId];
            });
            favoritesContext.setFavorites(favorites);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.data]);

    if (!noFavorites && noData.current) {
        return <Loader />
    }

    let matches = [];
    const sports = {};
    if (!noFavorites) {
        matches = filterSearchResults(Object.values(favorites), props.search, 'MATCH', function(match) {
            return match.desc;
        });
        matches.forEach(match => {
            if (sports[match.sportRef] === undefined) {
                sports[match.sportRef] = {};
            }
            const matchesByTournament = sports[match.sportRef];
            if (matchesByTournament[match.tournamentRef] === undefined) {
                matchesByTournament[match.tournamentRef] = [];
            }
            matchesByTournament[match.tournamentRef].push(match);
        });
    }

	return (
        <>
            {matches.length > 0 ?
                Object.keys(sports).map(sportId => {
                    const sportTournaments = Object.values(sports[sportId]);
                    return (
                        <FavouritesListSport key={sportId}
                                                id={sportId}
                                                tournaments={sportTournaments}
                                                changeMatch={props.changeMatch}
                                                currentMatch={props.currentMatch}
                                                isLiveSuite={props.isLiveSuite} />
                    );
                })
                :
                <div className="bg-nero bianco titolo-blocco-sport pointer">
                     <span className="d-centro-v maiuscolo">
                         <p>{getLabel('general.preferiti.specs')}</p>
                     </span>
                </div>
            }
        </>
    );
}

export default FavouritesList;